import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Sidebar from './Sidebar';
import Navbar from './Navbar';

const Layout = () => {
    const { sidebarOpen, darkMode } = useSelector(state => state.ui);
  
    useEffect(() => {
      // Apply dark mode class to html element
      if (darkMode) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    }, [darkMode]);
  
    return (
      <div className="flex h-screen bg-gray-100 dark:bg-gray-900">
        <Sidebar />
        
        <div className={`flex flex-col flex-1 ${sidebarOpen ? 'md:ml-64' : ''} transition-all duration-300 ease-in-out`}>
          <Navbar />
          
          <main className="flex-1 overflow-y-auto p-4 md:p-6">
            <Outlet />
          </main>
          
          <footer className="p-4 bg-white dark:bg-gray-800 shadow-inner">
            <p className="text-center text-gray-600 dark:text-gray-400 text-sm">
              © {new Date().getFullYear()} School Admin Panel. All rights reserved.
            </p>
          </footer>
        </div>
      </div>
    );
}

export default Layout
